var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEntferntSilikonUndKleberueckstaende = function SvgEntferntSilikonUndKleberueckstaende(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Entfernt_Silikon-und_Kleberueckstaende_svg__Ebene_2",
    viewBox: "0 0 107.91 100.99"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Entfernt_Silikon-und_Kleberueckstaende_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h107.91v100.99H0z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Entfernt_Silikon-und_Kleberueckstaende_svg__cls-2{fill:none;stroke-width:3.03px;stroke:currentColor;stroke-miterlimit:10}"))), /*#__PURE__*/React.createElement("g", {
    id: "Entfernt_Silikon-und_Kleberueckstaende_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Entfernt_Silikon-und_Kleberueckstaende_svg__clippath)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m82.59 71.16-28.33-2.5 16.97-22.82 11.35 25.32Zm-7.87-30.54L50.41 73.29 2.11 36.72 26.42 4.05l48.3 36.56ZM91.45 88.22l-6.56-11.23-6.56 11.23a7.38 7.38 0 0 0 0 7.51c1.37 2.35 3.82 3.75 6.56 3.75s5.19-1.4 6.56-3.75 1.37-5.16 0-7.52Z",
    className: "Entfernt_Silikon-und_Kleberueckstaende_svg__cls-2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m7.99 93.59 2.77 2.97 96.73-93.15-2.78-2.98z",
    style: {
      fill: "currentColor754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.76 96.56-2.77-2.97L104.71.43l2.78 2.98z",
    style: {
      stroke: "currentColor",
      strokeMiterlimit: 10,
      fill: "currentColor",
      strokeWidth: ".61px"
    }
  })));
};
export default SvgEntferntSilikonUndKleberueckstaende;